import { analysisTargetPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { MediaAnalysisTarget } from '@/common/model/media/mediaAnalysisTarget'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import AnalysisTargetForm from '@/components/container/form/modules/media/analysisTarget/AnalysisTargetForm'

interface Props {
  target?: MediaAnalysisTarget
  onRefetch?: () => void
}

const AnalysisTargetEditPage = ({ target, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <Main type={MainLayoutType.SMALL}>
      <BackButton link={analysisTargetPath(siteId)} />
      <AnalysisTargetForm target={target} onRefetch={onRefetch} />
    </Main>
  )
}

export default AnalysisTargetEditPage
